export const FormDateRangePickerDefProps = {
  startDate: '',
  endDate: '',
  onDatesChange: () => {return {startDate: '', endDate: ''}}
};